﻿$.fn.dxCtrlFileUploaderMachine = function custom_dxCtrlFileUploaderMachine(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfileuploadermachine dx-ctrl");
        this.createInstance(new cdxCtrlFileUploaderMachine(this, option));
    }
    return this;
}

//dans webconfig:
//MaxRequestLength = Ko (/1024 pour avoir des Mo)
//maxAllowedContentLength = octet (/1024/1024 pour avoir des Mo)
//pour un fichier de 82 843 Ko, il faut:
//MaxRequestLength= 82843
//maxAllowedContentLength=82843*1024 = 84 831 232
//pour un fichier de 82 843 Ko, il faut:
//MaxRequestLength= 82843
//maxAllowedContentLength=82843*1024 = 84 831 232
//Pour 100Mo, il faut MaxRequestLength= 102400 et maxAllowedContentLength=104 857 600

//41943040, //40Mo
//20971520, //20Mo
window.tailleMaxOctet = 104857600 * 3 //octet (100 Mo * 3)
window.maxAllowedContentLength = 104857600 * 3
window.MaxRequestLength = 102400 * 3
window.cdxCtrlFileUploaderMachine = function (container, option) {
    var Me = this;
    if (typeof option.accept == 'undefined') option.accept = "";
    if (typeof option.multiple == 'undefined') option.multiple = false;

    if (typeof option.maxFileSizeOctet == 'undefined') option.maxFileSizeOctet = tailleMaxOctet
    if (typeof option.maxFileSizeOctetImage == 'undefined') option.maxFileSizeOctetImage = tailleMaxOctet
    if (typeof option.maxFileSizeOctetFichier == 'undefined') option.maxFileSizeOctetFichier = tailleMaxOctet
    if (typeof option.maxFileSize != 'undefined') {
        option.maxFileSizeOctet = option.maxFileSize
        option.maxFileSizeOctetImage = option.maxFileSize
        option.maxFileSizeOctetFichier = option.maxFileSize
    }

    var dxFileUp = null;
    var $DivMess = null;
    this.dxScrollView = null;
    var jauge = null;
    var funcEndLoading = null;
    this.isInUpload = false;
    this.isInDrag = false;
    var $Filigrame = null;
    var $Background = null;

    this.$containerDragDrop = null

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            switch (name) {
                case "multiple":
                    dxFileUp.option("multiple", option.multiple);
                    break;
                case "accept":
                    dxFileUp.option("accept", option.accept);
                    mInitLibelle();
                    break;
                case "uploadUrl":
                    dxFileUp.option("uploadUrl", option.uploadUrl)
                    break;
                case "pathTempUpload":
                    dxFileUp.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload))
                    break;
            }
        }
    }

    var dx = null;
    function mConstruit() {
        container.empty();

        if (!container.hasClass("dx-theme-background-color")) container.addClass("dx-theme-background-color");
        var $DivContainer = $("<div style='height:100%;width:100%;'/>").appendTo(container)
        $DivContainer.css({
            width: "100%",
            height: "100%",
            "position": "relative",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center"
        })

        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance");

        funcEndLoading = function (lstFile) {
            if (option.onValide) option.onValide(lstFile);
            dxFileUp.element().find(".dx-fileuploader-files-container").empty();
            dxFileUp.element().find(".dx-fileuploader-wrapper").removeClass("dx-theme-background-color")
            dxFileUp.element().find(".dx-fileuploader-input-wrapper").css("display", "")
            if (typeof option.onDragEnd != 'undefined') option.onDragEnd($DivContainer)
            if (dxFileUp.lstFileErreur.length > 0) mShowToastErreurFile(dxFileUp.lstFileErreur)
            dxFileUp.lstFileErreur = [];
            dxFileUp.lstFile = [];
            dxFileUp.lstDivProgress = []
            if (typeof option.onReset != 'undefined') option.onReset()
        }

        var isPathTemporaire = false
        if (typeof option.pathTempUpload == 'undefined' || !option.pathTempUpload) {
            isPathTemporaire = true;
            option.bddCtrl.mAjaxCall({ command: "getpathvirtueltemporaire" }, function (data) {
                option.pathTempUpload = data.path;
                dxFileUp.option("disabled", false);
                dxFileUp.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload))
            });
        }

        dxFileUp = $("<div style='padding:20px;'/>").appendTo($DivContainer).dxFileUploader({
            hoverStateEnabled: false,
            disabled: ((typeof option.pathTempUpload == 'undefined' || !option.pathTempUpload) ? true : false),
            buttonText: 'Sélectionner des fichiers',
            maxFileSize: ((typeof option.maxFileSize == 'undefined') ? 2147483647 : option.maxFileSize),
            labelText: '',
            uploadedMessage: "Télétransmis",
            uploadFailedMessage: "Erreur de télétransmission",
            height: ((typeof option.height != 'undefined') ? option.height : "100%"),
            width: "100%",
            multiple: ((typeof option.multiple == 'undefined') ? false : option.multiple),
            //visible: false,
            uploadMode: "useButtons",
            accept: ((typeof option.accept == 'undefined') ? "" : option.accept),
            uploadUrl: '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + option.pathTempUpload,
            //uploadUrl: '/handler/HandlerUpload.ashx?dest=' + option.pathTempUpload,
            onUploaded: function (e) {
                e.component.nbFileInLoad -= 1;
                var newName = e.file.name
                //on récupère le nouveau nom du fichier qui a put être modifié sur le serveur
                try {
                    var response = JSON.parse(e.request.response);
                    if (typeof response.root.jsonfile != 'undefined') {
                        var trait = JSON.parse(response.root.jsonfile).files.filter(function (o) { return o.oldName.normalize("NFC") == e.file.name.normalize("NFC") })[0]
                        if (typeof trait != 'undefined') {
                            newName = trait.newName
                        } else {
                            try {
                                throw new Error("WARNING: Pas de nouveau nom pour le fichier: " + response.root.jsonfile);
                            } catch (e) {
                                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                            }
                        }
                    }
                } catch (e) { mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange") }
                //on crée un nouvelle objet si changement de nom
                var file = {
                    lastModified: e.file.lastModified,
                    lastModifiedDate: e.file.lastModifiedDate,
                    name: newName,
                    size: e.file.size,
                    type: e.file.type,
                    webkitRelativePath: e.file.webkitRelativePath
                }
                file.url = option.pathTempUpload + "/" + file.name;
                e.component.lstFile.push(file)
                $.each(e.component.option("value"), function (index, value) {
                    if (value.name == e.file.name && typeof e.component.lstDivProgress[index] != 'undefined') e.component.lstDivProgress[index].remove();
                });
                if (e.component.nbFileInLoad == 0) {
                    if (isPathTemporaire) {
                        dxFileUp.option("disabled", true);
                        option.bddCtrl.mAjaxCall({ command: "getpathvirtueltemporaire" }, function (data) {
                            option.pathTempUpload = data.path
                            dxFileUp.option("disabled", false);
                            dxFileUp.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload))
                        });
                    }
                    if (option.pathTempUpload.startsWith("~/fichier/" + option.bddCtrl.nom_base + "/documents_partages") ||
                        option.pathTempUpload.startsWith("/fichier/" + option.bddCtrl.nom_base + "/documents_partages") ||
                        option.pathTempUpload.startsWith("~/fichier/" + option.bddCtrl.nom_base + "/documents_publics") ||
                        option.pathTempUpload.startsWith("/fichier/" + option.bddCtrl.nom_base + "/documents_publics") ||
                        option.pathTempUpload.startsWith("~/fichier/" + option.bddCtrl.nom_base + "/utidoc") ||
                        option.pathTempUpload.startsWith("/fichier/" + option.bddCtrl.nom_base + "/utidoc")) {
                        //on a copié dans la box
                        option.bddCtrl.mAjaxCall({ command: "calculfilelucenedownloadedbox", lstFile: e.component.lstFile }, function (data) {
                        });
                        mNotify(((e.component.nbFileUploaded == 1) ? "Le fichier a été déposé dans votre box." : "Les fichiers ont été déposés dans votre box."), "success", 4000);
                    }
                    funcEndLoading(e.component.lstFile);
                    e.component.reset();
                    Me.isInUpload = false;
                }
                console.log("Fin: " + file.name);
            },
            onUploadAborted: function (e) {
                e.component.nbFileInLoad -= 1;
                e.file.abort = true
                e.component.lstFileErreur.push(e.file);
                if (e.component.nbFileInLoad == 0) {
                    funcEndLoading(e.component.lstFile);
                }
                console.log("Fin: " + e.file.name);
            },
            onUploadError: function (e) {
                e.component.nbFileInLoad -= 1;
                e.file.erreur = ((e.request.statusText.length == 0) ? e.message : e.request.statusText)
                e.component.lstFileErreur.push(e.file);
                if (e.component.nbFileInLoad == 0) {
                    funcEndLoading(e.component.lstFile);
                }
                console.log("Fin: " + e.file.name);
            },
            onUploadStarted: function (e) {
                if (typeof option.onUploadStarted != 'undefined') option.onUploadStarted();
                e.component.nbFileUploaded += 1
                Me.isInUpload = true;
                e.component.lstDivProgress = [];
                $.each(e.component.option("value"), function (index, value) {
                    e.component.lstDivProgress.push($(e.element.find(".dx-fileuploader-files-container").children()[index]))
                });
                e.component.element().find(".dx-fileuploader-wrapper").addClass("dx-theme-background-color")
                e.component.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload))
                if (parametre.isMobile && option.popup && !option.popup.option("visible")) option.popup.show();
                if (parametre.isDesktop && e.component.nbFileInLoad == 0) {
                    e.component.element().find(".dx-fileuploader-input-wrapper").css("display", "none");
                    $DivMess.css("display", "none");
                }
                //e.component.option("visible", true);
                e.component.nbFileInLoad += 1;
            },
            onValueChanged: function (e) {
                if (e.component.inOnValueChanged) return;
                if (e.component.timeOutDrop) window.clearTimeout(e.component.timeOutDrop);
                e.component.nbFileUploaded = 0
                if (typeof option.pathTempUpload != 'undefined' &&
                    (option.pathTempUpload.toLowerCase().startsWith("~/fichier/" + option.bddCtrl.nom_base + "/documents") ||
                        option.pathTempUpload.toLowerCase().startsWith("/fichier/" + option.bddCtrl.nom_base + "/documents"))) {
                    var lstFile = []
                    e.value.forEach(function (f) {
                        var nf = {}
                        for (var prop in f) { nf[prop] = f[prop] }
                        lstFile.push(nf);
                    });
                    var lstDir = [];
                    lstFile.forEach(function (f) { if ((f.size == 0 || f.size == 4096) & f.type == "") { lstDir.push(f); } });
                    if (lstDir.length > 0) {
                        if (lstDir.length == lstFile.length) {
                            mNotify("Vous ne pouvez pas télétransmettre des répertoires.", "error", 6000);
                            funcEndLoading([])
                            return;
                        }
                        else {
                            var txt = ""
                            lstDir.forEach(function (dir) {
                                if (txt.length > 0) txt += " &bull; "
                                txt += dir.name;
                                var values = e.component.option("value");
                                var lstDivRemove = [];
                                e.component.inOnValueChanged = true;
                                $.each(values, function (index, value) {
                                    lstDir.forEach(function (f) {
                                        //on annule le téléchargement
                                        if (value.name == f.name) {
                                            e.element.find(".dx-fileuploader-files-container .dx-fileuploader-cancel-button").eq(index).trigger("dxclick");
                                            lstDivRemove.push($(e.element.find(".dx-fileuploader-files-container").children()[index]));
                                        }
                                    });
                                });
                                lstDivRemove.forEach(function (div) { div.remove(); });
                                e.component.inOnValueChanged = false;
                            });
                            mNotify("Vous ne pouvez pas télétransmettre les répertoires<br/>" + txt, "error", 100000);
                        }
                    }
                    var lstFileTropGros = mGetLstFileTropGros(lstFile)
                    if (lstFileTropGros.length > 0) {
                        if (lstFileTropGros.length == lstFile.length) {
                            var message = mGetMessageTropGros(lstFileTropGros)
                            mNotify(message, "warning", 6000 + lstFileTropGros.length * 4000);
                            funcEndLoading([])
                            e.component.reset();
                            return;
                        } else {
                            var popQuestion = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                width: 400,
                                height: 625,
                                shading: true,
                                fullScreen: false,
                                showMaximize: false,
                                title: "Taille de fichier",
                                contentTemplate: function (contentElement) {
                                    $("<div style='padding:0 10px 10px 5px'><span style='font-size:120%'>Vous pouvez télétransmettre des fichier d'une taille maximum de <b>" + (Math.round(option.maxFileSizeOctetImage / 1024 / 1024 * 100) / 100) + "Mo pour les images</b> et de <b>" + (Math.round(option.maxFileSizeOctetFichier / 1024 / 1024 * 100) / 100) + "Mo pour les autres fichiers</b>.</span><br/><br/>Parmi vos <b>" + lstFile.length + "</b> fichiers, <b>" + lstFileTropGros.length + "</b> " + ((lstFileTropGros.length == 1) ? "a une taille trop important pour être télétransmis" : "ont une taille trop importante pour être télétransmis.") + "</div>").appendTo(contentElement)

                                    var txt = "";
                                    lstFileTropGros.forEach(function (f) {
                                        if (txt.length > 0) txt += " &bull; ";
                                        txt += "<b>" + f.file.name + "(" + (Math.round(f.file.size / 1024 / 1024 * 100) / 100) + "Mo)</b>";
                                    });

                                    $("<div style='padding:0 10px 10px 5px;text-align:center;height:360px;'>" + txt + "</div>").appendTo(contentElement)

                                    var nbReste = lstFile.length - lstFileTropGros.length
                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                                        text: "Télétransmettre " + ((nbReste == 1) ? "le fichier restant" : "les autres fichiers"),
                                        width: "100%",
                                        onClick: function () {
                                            popQuestion.hide();
                                            var values = e.component.option("value");
                                            var lstDivRemove = [];
                                            e.component.inOnValueChanged = true;
                                            $.each(values, function (index, value) {
                                                lstFileTropGros.forEach(function (fTropGros) {
                                                    //on annule le téléchargement
                                                    if (value.name == fTropGros.file.name) {
                                                        e.element.find(".dx-fileuploader-files-container .dx-fileuploader-cancel-button").eq(index).trigger("dxclick");
                                                        lstDivRemove.push($(e.element.find(".dx-fileuploader-files-container").children()[index]));
                                                        lstFile.splice(lstFile.indexOf(fTropGros.file), 1)
                                                    }
                                                });
                                            });
                                            lstDivRemove.forEach(function (div) { div.remove(); });
                                            e.component.inOnValueChanged = false;
                                            mStart();
                                        }
                                    });
                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                                        text: "Annuler",
                                        width: "100%",
                                        onClick: function () {
                                            popQuestion.hide();
                                            e.component.reset();
                                            funcEndLoading([]);
                                        }
                                    });
                                },
                                onHiding: function (e) { funcEndLoading([]); }
                            }).dxCtrlPopupBase("instance")
                            popQuestion.show();
                        }
                    } else { mStart(); }

                    function mStart() {
                        jauge.mShowTempo();
                        option.bddCtrl.mAjaxCall({ command: "getlstfichierexist", url: option.pathTempUpload, files: lstFile },
                            function (data) {
                                if (typeof data.files != 'undefined' && data.files.length > 0) {
                                    var popQuestion = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                        width: 400,
                                        height: ((lstFile.length == 1) ? 205 : 645),
                                        shading: true,
                                        fullScreen: false,
                                        showMaximize: false,
                                        title: "Fichier existant",
                                        contentTemplate: function (contentElement) {
                                            if (lstFile.length == 1) {
                                                $("<div style='padding:0 10px 10px 5px'>Le fichier <b>" + lstFile[0].name + "</b> existe déjà dans le répertoire.</div>").appendTo(contentElement)
                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                                    text: "Remplacer le fichier",
                                                    width: "100%",
                                                    onClick: function () {
                                                        popQuestion.hide();
                                                        e.component._uploadFiles();
                                                    }
                                                });
                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                                    text: "Annuler",
                                                    width: "100%",
                                                    onClick: function () {
                                                        popQuestion.hide();
                                                        funcEndLoading([])
                                                    }
                                                });
                                            }
                                            else {
                                                $("<div style='padding:0 10px 10px 5px'>sur les <b>" + lstFile.length + "</b> fichiers, <b>" + data.files.length + "</b> " + ((data.files.length == 1) ? "fichier existe" : "fichiers existent") + " déjà dans le répertoire. Que voulez vous faire pour " + ((data.files.length == 1) ? "ce fichier" : "ces fichiers") + "?</div>").appendTo(contentElement)
                                                var txt = "";
                                                data.files.forEach(function (f) {
                                                    if (txt.length > 0) txt += " &bull; ";
                                                    txt += "<b>" + f + "</b>";
                                                });

                                                $("<div style='padding:0 10px 10px 5px;text-align:center;height:400px;'>" + txt + "</div>").appendTo(contentElement)
                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                                    text: "Ignorer " + ((data.files.length == 1) ? "le fichier" : "les " + data.files.length + " fichiers"),
                                                    width: "100%",
                                                    onClick: function () {
                                                        popQuestion.hide();
                                                        if (data.files.length == lstFile.length) {
                                                            funcEndLoading([])
                                                        }
                                                        else {
                                                            var values = e.component.option("value");
                                                            $.each(values, function (index, value) {
                                                                data.files.forEach(function (f) {
                                                                    //on annule le téléchargement
                                                                    if (value.name == f) {
                                                                        e.element.find(".dx-fileuploader-files-container .dx-fileuploader-cancel-button").eq(index).trigger("dxclick");
                                                                        lstFile.splice(lstFile.indexOf(value), 1)
                                                                    }
                                                                });
                                                            });
                                                            e.component.inOnValueChanged = false;
                                                            e.component.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload) + "&notoverwrite=1")
                                                            e.component._uploadFiles();
                                                        }
                                                    }
                                                });
                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                                    text: "Remplacer " + ((data.files.length == 1) ? "le fichier" : "les " + data.files.length + " fichiers"),
                                                    width: "100%",
                                                    onClick: function () {
                                                        popQuestion.hide();
                                                        e.component._uploadFiles();
                                                    }
                                                });
                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                                    text: "Annuler",
                                                    width: "100%",
                                                    onClick: function () {
                                                        popQuestion.hide();
                                                        funcEndLoading([])
                                                    }
                                                });
                                            }
                                        },
                                        onHiding: function (e) { funcEndLoading([]); }
                                    }).dxCtrlPopupBase("instance")
                                    popQuestion.show();
                                }
                                else { e.component._uploadFiles(); }
                            },
                            function () { jauge.mHide(); },
                            function () { });
                    }
                }
                else {
                    var lstFileTropGros = mGetLstFileTropGros(e.value)
                    var message = mGetMessageTropGros(lstFileTropGros)
                    if (message.length > 0) {
                        mNotify(message, "warning", 6000 + lstFileTropGros.length * 4000);
                        funcEndLoading([])
                    } else {
                        e.component._uploadFiles();
                    }
                }
            },
            onContentReady: function (e) {
                //Me.$containerDragDrop = $(e.component.element().closest(".dx-ctrlfileuploadermachine")[0])
                if (parametre.isMobile) {
                    e.component.element().find("input").attr("accept", ((parametre.isMobile ? "image/*,video/*" : "")))
                } else {
                    if (typeof option.accept == 'undefined' || option.accept == '') {
                        e.component.element().find("input").attr("accept", "")
                    } else if (option.accept.contains(".png") ||
                        option.accept.contains(".jpg") ||
                        option.accept.contains(".jpeg") ||
                        option.accept.contains(".gif") ||
                        option.accept.contains(".bmp")) {
                        //e.component.element().find("input").attr("capture", "user")
                        e.component.element().find("input").attr("accept", "image/*,video/*")
                    }
                }

                Me.$containerDragDrop = $(container.find(".dx-fileuploader-container"))
                e.component.lstFile = []; e.component.lstFileErreur = []; e.component.lstDivProgress = [];
                e.component.nbFileInLoad = 0;
                e.component.inOnValueChanged = false;
                $DivMess = $("<div style='position:absolute;z-index:6;top:55px;color:gray;width:100%;text-align:center;cursor:pointer;'>ou glissez-déposez les fichiers ici.</div>")
                $Filigrame = $("<i class='fas fa-cloud-upload-alt' style='user-select:none;position:absolute;font-size:300px;opacity:0.1;z-index:0;pointer-events:none;'/>");
                $Background = $("<div style='position:absolute;width:100%;height:100%;background-color:gray;display:none;pointer-events:none;'/>")
                $DivContainer.prepend($Filigrame);
                $DivContainer.prepend($DivMess);
                $DivContainer.prepend($Background);
                e.component.element().find(".dx-fileuploader-button").css("display", "none");
                e.component.element().find(".dx-fileuploader-input-wrapper").css({ "width": "100%", "height": "100%" });
                e.component.element().css({ position: "relative", "z-index": 0 });
                e.component.element().find(".dx-fileuploader-wrapper").css("padding", "0");
                e.component.element().find(".dx-fileuploader-input-wrapper").css("padding", "0");
                //e.component.element().find(".dx-fileuploader-container").css("padding", "20px");
                e.component.element().css("cursor", "pointer")
                e.component.dragCounter = 0;
                Me.isInDrag = false;
                $DivContainer.on("click", function () {
                    Me.mSelectionneFichier()
                })

                // Firefox exige un preventDefault() sur dragover pour autoriser le drop
                // (sinon le navigateur refuse le drop ou ouvre le fichier lui-même).
                Me.$containerDragDrop.on("dragover", function (ev) {
                    ev.preventDefault();
                });

                // Utilisation d'un compteur de profondeur au lieu d'un flag + setTimeout(0)
                // basé sur la classe interne "dx-fileuploader-dragover" de DevExtreme :
                // cette dernière technique dépend de l'ordre exact des événements
                // dragenter/dragleave imbriqués, qui n'est pas garanti identique entre
                // Chrome et Firefox. Le compteur, lui, est fiable quel que soit le
                // navigateur, même quand on survole des éléments enfants de la zone.
                Me.$containerDragDrop.on("dragenter", function (ev) {
                    ev.preventDefault();
                    e.component.dragCounter++;
                    if (e.component.dragCounter === 1) {
                        e.component.element().find(".dx-fileuploader-content").css("z-index", 1)
                        e.component.element().css("z-index", 10);
                        e.component.element().css("opacity", "0.5");
                        e.component.element().css("background-color", "transparent");
                        $Background.show()
                        console.log("dragenter " + (new Date()).getTime())
                        Me.isInDrag = true;
                        console.log("isindrag(enter) = true")
                    }
                });
                Me.$containerDragDrop.on("dragleave", function (ev) {
                    ev.preventDefault();
                    e.component.dragCounter--;
                    if (e.component.dragCounter <= 0) {
                        e.component.dragCounter = 0;
                        e.component.element().css("z-index", 0);
                        e.component.element().css("opacity", "1");
                        e.component.element().css("background-color", "transparent");
                        $Background.hide()
                        e.component.element().css("border", "none");
                        console.log("dragleave " + (new Date()).getTime())
                        if (typeof option.onDragEnd != 'undefined') option.onDragEnd(Me.$containerDragDrop)
                        Me.isInDrag = false;
                        console.log("isindrag = false")
                    }
                });
                Me.$containerDragDrop.on("drop", function (ev) {
                    ev.preventDefault();
                    e.component.dragCounter = 0;
                    e.component.element().css("z-index", "0");
                    e.component.element().css("opacity", "1");
                    e.component.element().css("background-color", "transparent");
                    e.component.element().find(".dx-fileuploader-input-wrapper").css("display", "none")
                    $Background.hide()
                    console.log("drop " + (new Date()).getTime())

                    var valeurDejaPresente = e.component.option("value") && e.component.option("value").length > 0;
                    if (!valeurDejaPresente) {
                        // Sur Firefox, le mécanisme interne de dxFileUploader qui transforme
                        // le "drop" natif en fichiers dans "value" ne se déclenche pas de
                        // façon fiable pour ce widget. On récupère alors nous-mêmes les
                        // fichiers depuis dataTransfer et on les injecte dans le composant.
                        // (Le test ci-dessus évite de dupliquer les fichiers sur les
                        // navigateurs où le mécanisme interne fonctionne déjà, comme Chrome.)
                        var dt = ev.originalEvent && ev.originalEvent.dataTransfer;
                        if (dt && dt.files && dt.files.length > 0) {
                            var lstFilesDeposes = [];
                            for (var i = 0; i < dt.files.length; i++) lstFilesDeposes.push(dt.files[i]);
                            console.log("drop: injection manuelle de " + lstFilesDeposes.length + " fichier(s) (dxFileUploader n'a rien peuplé)")
                            e.component.option("value", lstFilesDeposes);
                        } else {
                            e.component.timeOutDrop = window.setTimeout(function () {
                                funcEndLoading([]);
                            }, 100);
                        }
                    }
                    Me.isInDrag = false;
                    console.log("isindrag(drop) = false")
                });
                if (typeof option.onContentReady != 'undefined') option.onContentReady(e)
            }
        }).dxFileUploader("instance");
        mInitLibelle();
    }

    function mInitLibelle() {
        dxFileUp.option('buttonText', ((option.multiple) ? 'Choisir des fichiers' : "Choisir un fichier"))
        if ($DivMess) $DivMess.html(((option.multiple) ? 'Cliquez pour choisir des fichiers<br/>ou<br/>glissez-déposez les fichiers ici...' : "Cliquez pour choisir un fichier<br/>ou<br/>glissez-déposez le fichier ici..."))
    }

    function mGetLstFileTropGros(lstValue) {
        var lstFile = []
        lstValue.forEach(function (f) {
            var nf = {}
            for (var prop in f) { nf[prop] = f[prop] }
            lstFile.push(nf);
        });
        var lstFileTropGros = [];
        lstFile.forEach(function (f) {
            if (((new cFichier(option.bddCtrl, f.name)).mIsImage() && f.size > option.maxFileSizeOctetImage) || (!(new cFichier(option.bddCtrl, f.name)).mIsImage() && f.size > option.maxFileSizeOctetFichier)) {
                lstFileTropGros.push({ file: f, max: (((new cFichier(option.bddCtrl, f.name)).mIsImage()) ? option.maxFileSizeOctetImage : option.maxFileSizeOctetFichier) });
            }
        });
        return lstFileTropGros
    }
    function mGetMessageTropGros(lstFileTropGros) {
        if (lstFileTropGros.length > 0) {
            var txt = "Le fichier suivant est trop gros pour être télétransmis:"
            if (lstFileTropGros.length > 0) txt = "Les fichiers suivants sont trop gros pour être télétransmis:"
            lstFileTropGros.forEach(function (fTropGros) {
                txt += "<br/>Le fichier <b><u>" + fTropGros.file.name + "</u></b> fait <span style='color:red'>" + (Math.round((fTropGros.file.size / 1024 / 1024) * 100) / 100) + "Mo</span> pour une taille maximum de <b style='color:green'>" + (Math.round((fTropGros.max / 1024 / 1024) * 100) / 100) + "Mo</b>"
            })
            txt += "<br/><b>Télétransmission annulée.</b>"
            return txt
        } else { return "" }
    }

    //function mRecalculFiligrane() {
    //    //$DivMess.css("left", "calc(50% - " + ($DivMess.innerWidth() / 2) + "px)");
    //    var fontSize = 300
    //    if (container.innerHeight() < 300) fontSize = container.innerHeight() - 10
    //    if ($Filigrame) $Filigrame.css({ top: "calc(50% - " + $Filigrame.innerHeight() / 2 + "px)", left: "calc(50% - " + $Filigrame.innerWidth() / 2 + "px)", "font-size": fontSize + "px" })
    //}

    this.isInDragOver = function () {
        return (container.find(".dx-fileuploader-dragover").length >= 1)
    }

    //var carInterdit = ['+', '#', '&', '%', ':', '/', '\\', '*', '?', '"', '<', '>', "'", '"', String.fromCharCode(8217)]
    var maxCarAscii = 255
    function mRenameFileWithoutCarInterdit(fileName) {
        fileName = fileName.remplacerTout(String.fromCharCode(8217), "'")
        carInterditFichier.forEach(function (car) { fileName = fileName.remplacerTout(car, "_") })
        for (var i = maxCarAscii + 1; i <= 255; i++) {
            //if (fileName.indexOf(String.fromCharCode(i)) > -1) debugger;
            fileName = fileName.remplacerTout(String.fromCharCode(i), "_")
        }
        return fileName;
    }

    function mShowToastErreurFile(lstFile) {
        var txt = ""
        lstFile.forEach(function (file) {
            if (txt.length > 0) txt += " &bull; "
            txt += "Impossible de télétransmettre le fichier '" + file.name + "'"
            if (typeof file.abort != 'undefined') { txt += " (Annulé par l'utilisateur)" }
            if (typeof file.erreur != 'undefined') { txt += "<br><span style='font-size:80%;'>(<i>" + file.erreur + "</i>)</span>" }
        })
        mNotify(txt, "error", 12000)
    }

    function mClearListFile() {
        dxFileUp.element().find(".dx-fileuploader-files-container").empty()
        dxFileUp.lstFile = [];
        dxFileUp.lstFileErreur = [];
    }

    this.mShowJauge = function (tempo) { jauge.mShow(tempo) }
    var uniquementImage = false;
    this.mAllowImage = function () {
        this.mAllowedExtension(".png,.jpg,.jpeg,.gif,.bmp");
        uniquementImage = true
    }
    this.mAllowAll = function () {
        this.mAllowedExtension("");
        uniquementImage = false
    }

    var timeOutClickButton = null;
    this.mSelectionneFichier = function () {
        if (timeOutClickButton) window.clearTimeout(timeOutClickButton);
        timeOutClickButton = window.setTimeout(function () {
            dxFileUp._isCustomClickEvent = true;
            dxFileUp._$fileInput.click();
        }, 100);
    }

    this.element = function () { return container; }


    mConstruit();
}

//$.fn.dxCtrlFileUploaderMachine = function custom_dxCtrlFileUploaderMachine(option) {
//    if (option == "instance") {
//        return this.instance;
//    }
//    else {
//        this.addClass("dx-ctrlfileuploadermachine dx-ctrl");
//        this.createInstance(new cdxCtrlFileUploaderMachine(this, option));
//    }
//    return this;
//}

////dans webconfig:
////MaxRequestLength = Ko (/1024 pour avoir des Mo)
////maxAllowedContentLength = octet (/1024/1024 pour avoir des Mo)
////pour un fichier de 82 843 Ko, il faut:
////MaxRequestLength= 82843
////maxAllowedContentLength=82843*1024 = 84 831 232
////pour un fichier de 82 843 Ko, il faut:
////MaxRequestLength= 82843
////maxAllowedContentLength=82843*1024 = 84 831 232
////Pour 100Mo, il faut MaxRequestLength= 102400 et maxAllowedContentLength=104 857 600

////41943040, //40Mo
////20971520, //20Mo
//window.tailleMaxOctet = 104857600 * 3 //octet (100 Mo * 3)
//window.maxAllowedContentLength = 104857600 * 3
//window.MaxRequestLength = 102400 * 3
//window.cdxCtrlFileUploaderMachine = function (container, option) {
//    var Me = this;
//    if (typeof option.accept == 'undefined') option.accept = "";
//    if (typeof option.multiple == 'undefined') option.multiple = false;

//    if (typeof option.maxFileSizeOctet == 'undefined') option.maxFileSizeOctet = tailleMaxOctet
//    if (typeof option.maxFileSizeOctetImage == 'undefined') option.maxFileSizeOctetImage = tailleMaxOctet
//    if (typeof option.maxFileSizeOctetFichier == 'undefined') option.maxFileSizeOctetFichier = tailleMaxOctet
//    if (typeof option.maxFileSize != 'undefined') {
//        option.maxFileSizeOctet = option.maxFileSize
//        option.maxFileSizeOctetImage = option.maxFileSize
//        option.maxFileSizeOctetFichier = option.maxFileSize
//    }

//    var dxFileUp = null;
//    var $DivMess = null;
//    this.dxScrollView = null;
//    var jauge = null;
//    var funcEndLoading = null;
//    this.isInUpload = false;
//    this.isInDrag = false;
//    var $Filigrame = null;
//    var $Background = null;

//    this.$containerDragDrop = null

//    this.option = function (name, value) {
//        if (typeof value == 'undefined') {
//            return option[name];
//        }
//        else {
//            option[name] = value;
//            switch (name) {
//                case "multiple":
//                    dxFileUp.option("multiple", option.multiple);
//                    break;
//                case "accept":
//                    dxFileUp.option("accept", option.accept);
//                    mInitLibelle();
//                    break;
//                case "uploadUrl":
//                    dxFileUp.option("uploadUrl", option.uploadUrl)
//                    break;
//                case "pathTempUpload":
//                    dxFileUp.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload))
//                    break;
//            }
//        }
//    }

//    var dx = null;
//    function mConstruit() {
//        container.empty();

//        if (!container.hasClass("dx-theme-background-color")) container.addClass("dx-theme-background-color");
//        var $DivContainer = $("<div style='height:100%;width:100%;'/>").appendTo(container)
//        $DivContainer.css({
//            width: "100%",
//            height: "100%",
//            "position": "relative",
//            "display": "flex",
//            "align-items": "center",
//            "justify-content": "center"
//        })

//        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance");

//        funcEndLoading = function (lstFile) {
//            if (option.onValide) option.onValide(lstFile);
//            dxFileUp.element().find(".dx-fileuploader-files-container").empty();
//            dxFileUp.element().find(".dx-fileuploader-wrapper").removeClass("dx-theme-background-color")
//            dxFileUp.element().find(".dx-fileuploader-input-wrapper").css("display", "")
//            if (typeof option.onDragEnd != 'undefined') option.onDragEnd($DivContainer)
//            if (dxFileUp.lstFileErreur.length > 0) mShowToastErreurFile(dxFileUp.lstFileErreur)
//            dxFileUp.lstFileErreur = [];
//            dxFileUp.lstFile = [];
//            dxFileUp.lstDivProgress = []
//            if (typeof option.onReset != 'undefined') option.onReset()
//        }

//        var isPathTemporaire = false
//        if (typeof option.pathTempUpload == 'undefined' || !option.pathTempUpload) {
//            isPathTemporaire = true;
//            option.bddCtrl.mAjaxCall({ command: "getpathvirtueltemporaire" }, function (data) {
//                option.pathTempUpload = data.path;
//                dxFileUp.option("disabled", false);
//                dxFileUp.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload))
//            });
//        }

//        dxFileUp = $("<div style='padding:20px;'/>").appendTo($DivContainer).dxFileUploader({
//            hoverStateEnabled: false,
//            disabled: ((typeof option.pathTempUpload == 'undefined' || !option.pathTempUpload) ? true : false),
//            buttonText: 'Sélectionner des fichiers',
//            maxFileSize: ((typeof option.maxFileSize == 'undefined') ? 2147483647 : option.maxFileSize),
//            labelText: '',
//            uploadedMessage: "Télétransmis",
//            uploadFailedMessage: "Erreur de télétransmission",
//            height: ((typeof option.height != 'undefined') ? option.height : "100%"),
//            width: "100%",
//            multiple: ((typeof option.multiple == 'undefined') ? false : option.multiple),
//            //visible: false,
//            uploadMode: "useButtons",
//            accept: ((typeof option.accept == 'undefined') ? "" : option.accept),
//            uploadUrl: '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + option.pathTempUpload,
//            //uploadUrl: '/handler/HandlerUpload.ashx?dest=' + option.pathTempUpload,
//            onUploaded: function (e) {
//                e.component.nbFileInLoad -= 1;
//                var newName = e.file.name
//                //on récupère le nouveau nom du fichier qui a put être modifié sur le serveur
//                try {
//                    var response = JSON.parse(e.request.response);
//                    if (typeof response.root.jsonfile != 'undefined') {
//                        var trait = JSON.parse(response.root.jsonfile).files.filter(function (o) { return o.oldName.normalize("NFC") == e.file.name.normalize("NFC") })[0]
//                        if (typeof trait != 'undefined') {
//                            newName = trait.newName
//                        } else {
//                            try {
//                                throw new Error("WARNING: Pas de nouveau nom pour le fichier: " + response.root.jsonfile);
//                            } catch (e) {
//                                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
//                            }
//                        }
//                    }
//                } catch (e) { mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange") }
//                //on crée un nouvelle objet si changement de nom
//                var file = {
//                    lastModified: e.file.lastModified,
//                    lastModifiedDate: e.file.lastModifiedDate,
//                    name: newName,
//                    size: e.file.size,
//                    type: e.file.type,
//                    webkitRelativePath: e.file.webkitRelativePath
//                }
//                file.url = option.pathTempUpload + "/" + file.name;
//                e.component.lstFile.push(file)
//                $.each(e.component.option("value"), function (index, value) {
//                    if (value.name == e.file.name && typeof e.component.lstDivProgress[index] != 'undefined') e.component.lstDivProgress[index].remove();
//                });
//                if (e.component.nbFileInLoad == 0) {
//                    if (isPathTemporaire) {
//                        dxFileUp.option("disabled", true);
//                        option.bddCtrl.mAjaxCall({ command: "getpathvirtueltemporaire" }, function (data) {
//                            option.pathTempUpload = data.path
//                            dxFileUp.option("disabled", false);
//                            dxFileUp.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload))
//                        });
//                    }
//                    if (option.pathTempUpload.startsWith("~/fichier/" + option.bddCtrl.nom_base + "/documents_partages") ||
//                        option.pathTempUpload.startsWith("/fichier/" + option.bddCtrl.nom_base + "/documents_partages") ||
//                        option.pathTempUpload.startsWith("~/fichier/" + option.bddCtrl.nom_base + "/documents_publics") ||
//                        option.pathTempUpload.startsWith("/fichier/" + option.bddCtrl.nom_base + "/documents_publics") ||
//                        option.pathTempUpload.startsWith("~/fichier/" + option.bddCtrl.nom_base + "/utidoc") ||
//                        option.pathTempUpload.startsWith("/fichier/" + option.bddCtrl.nom_base + "/utidoc")) {
//                        //on a copié dans la box
//                        option.bddCtrl.mAjaxCall({ command: "calculfilelucenedownloadedbox", lstFile: e.component.lstFile }, function (data) {
//                        });
//                        mNotify(((e.component.nbFileUploaded == 1) ? "Le fichier a été déposé dans votre box." : "Les fichiers ont été déposés dans votre box."), "success", 4000);
//                    }
//                    funcEndLoading(e.component.lstFile);
//                    e.component.reset();
//                    Me.isInUpload = false;
//                }
//                console.log("Fin: " + file.name);
//            },
//            onUploadAborted: function (e) {
//                e.component.nbFileInLoad -= 1;
//                e.file.abort = true
//                e.component.lstFileErreur.push(e.file);
//                if (e.component.nbFileInLoad == 0) {
//                    funcEndLoading(e.component.lstFile);
//                }
//                console.log("Fin: " + e.file.name);
//            },
//            onUploadError: function (e) {
//                e.component.nbFileInLoad -= 1;
//                e.file.erreur = ((e.request.statusText.length == 0) ? e.message : e.request.statusText)
//                e.component.lstFileErreur.push(e.file);
//                if (e.component.nbFileInLoad == 0) {
//                    funcEndLoading(e.component.lstFile);
//                }
//                console.log("Fin: " + e.file.name);
//            },
//            onUploadStarted: function (e) {
//                if (typeof option.onUploadStarted != 'undefined') option.onUploadStarted();
//                e.component.nbFileUploaded += 1
//                Me.isInUpload = true;
//                e.component.lstDivProgress = [];
//                $.each(e.component.option("value"), function (index, value) {
//                    e.component.lstDivProgress.push($(e.element.find(".dx-fileuploader-files-container").children()[index]))
//                });
//                e.component.element().find(".dx-fileuploader-wrapper").addClass("dx-theme-background-color")
//                e.component.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload))
//                if (parametre.isMobile && option.popup && !option.popup.option("visible")) option.popup.show();
//                if (parametre.isDesktop && e.component.nbFileInLoad == 0) {
//                    e.component.element().find(".dx-fileuploader-input-wrapper").css("display", "none");
//                    $DivMess.css("display", "none");
//                }
//                //e.component.option("visible", true);
//                e.component.nbFileInLoad += 1;
//            },
//            onValueChanged: function (e) {
//                if (e.component.inOnValueChanged) return;
//                if (e.component.timeOutDrop) window.clearTimeout(e.component.timeOutDrop);
//                e.component.nbFileUploaded = 0
//                if (typeof option.pathTempUpload != 'undefined' &&
//                    (option.pathTempUpload.toLowerCase().startsWith("~/fichier/" + option.bddCtrl.nom_base + "/documents") ||
//                        option.pathTempUpload.toLowerCase().startsWith("/fichier/" + option.bddCtrl.nom_base + "/documents"))) {
//                    var lstFile = []
//                    e.value.forEach(function (f) {
//                        var nf = {}
//                        for (var prop in f) { nf[prop] = f[prop] }
//                        lstFile.push(nf);
//                    });
//                    var lstDir = [];
//                    lstFile.forEach(function (f) { if ((f.size == 0 || f.size == 4096) & f.type == "") { lstDir.push(f); } });
//                    if (lstDir.length > 0) {
//                        if (lstDir.length == lstFile.length) {
//                            mNotify("Vous ne pouvez pas télétransmettre des répertoires.", "error", 6000);
//                            funcEndLoading([])
//                            return;
//                        }
//                        else {
//                            var txt = ""
//                            lstDir.forEach(function (dir) {
//                                if (txt.length > 0) txt += " &bull; "
//                                txt += dir.name;
//                                var values = e.component.option("value");
//                                var lstDivRemove = [];
//                                e.component.inOnValueChanged = true;
//                                $.each(values, function (index, value) {
//                                    lstDir.forEach(function (f) {
//                                        //on annule le téléchargement
//                                        if (value.name == f.name) {
//                                            e.element.find(".dx-fileuploader-files-container .dx-fileuploader-cancel-button").eq(index).trigger("dxclick");
//                                            lstDivRemove.push($(e.element.find(".dx-fileuploader-files-container").children()[index]));
//                                        }
//                                    });
//                                });
//                                lstDivRemove.forEach(function (div) { div.remove(); });
//                                e.component.inOnValueChanged = false;
//                            });
//                            mNotify("Vous ne pouvez pas télétransmettre les répertoires<br/>" + txt, "error", 100000);
//                        }
//                    }
//                    var lstFileTropGros = mGetLstFileTropGros(lstFile)
//                    if (lstFileTropGros.length > 0) {
//                        if (lstFileTropGros.length == lstFile.length) {
//                            var message = mGetMessageTropGros(lstFileTropGros)
//                            mNotify(message, "warning", 6000 + lstFileTropGros.length * 4000);
//                            funcEndLoading([])
//                            e.component.reset();
//                            return;
//                        } else {
//                            var popQuestion = $("<div/>").appendTo("body").dxCtrlPopupBase({
//                                width: 400,
//                                height: 625,
//                                shading: true,
//                                fullScreen: false,
//                                showMaximize: false,
//                                title: "Taille de fichier",
//                                contentTemplate: function (contentElement) {
//                                    $("<div style='padding:0 10px 10px 5px'><span style='font-size:120%'>Vous pouvez télétransmettre des fichier d'une taille maximum de <b>" + (Math.round(option.maxFileSizeOctetImage / 1024 / 1024 * 100) / 100) + "Mo pour les images</b> et de <b>" + (Math.round(option.maxFileSizeOctetFichier / 1024 / 1024 * 100) / 100) + "Mo pour les autres fichiers</b>.</span><br/><br/>Parmi vos <b>" + lstFile.length + "</b> fichiers, <b>" + lstFileTropGros.length + "</b> " + ((lstFileTropGros.length == 1) ? "a une taille trop important pour être télétransmis" : "ont une taille trop importante pour être télétransmis.") + "</div>").appendTo(contentElement)

//                                    var txt = "";
//                                    lstFileTropGros.forEach(function (f) {
//                                        if (txt.length > 0) txt += " &bull; ";
//                                        txt += "<b>" + f.file.name + "(" + (Math.round(f.file.size / 1024 / 1024 * 100) / 100) + "Mo)</b>";
//                                    });

//                                    $("<div style='padding:0 10px 10px 5px;text-align:center;height:360px;'>" + txt + "</div>").appendTo(contentElement)

//                                    var nbReste = lstFile.length - lstFileTropGros.length
//                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
//                                        text: "Télétransmettre " + ((nbReste == 1) ? "le fichier restant" : "les autres fichiers"),
//                                        width: "100%",
//                                        onClick: function () {
//                                            popQuestion.hide();
//                                            var values = e.component.option("value");
//                                            var lstDivRemove = [];
//                                            e.component.inOnValueChanged = true;
//                                            $.each(values, function (index, value) {
//                                                lstFileTropGros.forEach(function (fTropGros) {
//                                                    //on annule le téléchargement
//                                                    if (value.name == fTropGros.file.name) {
//                                                        e.element.find(".dx-fileuploader-files-container .dx-fileuploader-cancel-button").eq(index).trigger("dxclick");
//                                                        lstDivRemove.push($(e.element.find(".dx-fileuploader-files-container").children()[index]));
//                                                        lstFile.splice(lstFile.indexOf(fTropGros.file), 1)
//                                                    }
//                                                });
//                                            });
//                                            lstDivRemove.forEach(function (div) { div.remove(); });
//                                            e.component.inOnValueChanged = false;
//                                            mStart();
//                                        }
//                                    });
//                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
//                                        text: "Annuler",
//                                        width: "100%",
//                                        onClick: function () {
//                                            popQuestion.hide();
//                                            e.component.reset();
//                                            funcEndLoading([]);
//                                        }
//                                    });
//                                },
//                                onHiding: function (e) { funcEndLoading([]); }
//                            }).dxCtrlPopupBase("instance")
//                            popQuestion.show();
//                        }
//                    } else { mStart(); }

//                    function mStart() {
//                        jauge.mShowTempo();
//                        option.bddCtrl.mAjaxCall({ command: "getlstfichierexist", url: option.pathTempUpload, files: lstFile },
//                            function (data) {
//                                if (typeof data.files != 'undefined' && data.files.length > 0) {
//                                    var popQuestion = $("<div/>").appendTo("body").dxCtrlPopupBase({
//                                        width: 400,
//                                        height: ((lstFile.length == 1) ? 205 : 645),
//                                        shading: true,
//                                        fullScreen: false,
//                                        showMaximize: false,
//                                        title: "Fichier existant",
//                                        contentTemplate: function (contentElement) {
//                                            if (lstFile.length == 1) {
//                                                $("<div style='padding:0 10px 10px 5px'>Le fichier <b>" + lstFile[0].name + "</b> existe déjà dans le répertoire.</div>").appendTo(contentElement)
//                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
//                                                    text: "Remplacer le fichier",
//                                                    width: "100%",
//                                                    onClick: function () {
//                                                        popQuestion.hide();
//                                                        e.component._uploadFiles();
//                                                    }
//                                                });
//                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
//                                                    text: "Annuler",
//                                                    width: "100%",
//                                                    onClick: function () {
//                                                        popQuestion.hide();
//                                                        funcEndLoading([])
//                                                    }
//                                                });
//                                            }
//                                            else {
//                                                $("<div style='padding:0 10px 10px 5px'>sur les <b>" + lstFile.length + "</b> fichiers, <b>" + data.files.length + "</b> " + ((data.files.length == 1) ? "fichier existe" : "fichiers existent") + " déjà dans le répertoire. Que voulez vous faire pour " + ((data.files.length == 1) ? "ce fichier" : "ces fichiers") + "?</div>").appendTo(contentElement)
//                                                var txt = "";
//                                                data.files.forEach(function (f) {
//                                                    if (txt.length > 0) txt += " &bull; ";
//                                                    txt += "<b>" + f + "</b>";
//                                                });

//                                                $("<div style='padding:0 10px 10px 5px;text-align:center;height:400px;'>" + txt + "</div>").appendTo(contentElement)
//                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
//                                                    text: "Ignorer " + ((data.files.length == 1) ? "le fichier" : "les " + data.files.length + " fichiers"),
//                                                    width: "100%",
//                                                    onClick: function () {
//                                                        popQuestion.hide();
//                                                        if (data.files.length == lstFile.length) {
//                                                            funcEndLoading([])
//                                                        }
//                                                        else {
//                                                            var values = e.component.option("value");
//                                                            $.each(values, function (index, value) {
//                                                                data.files.forEach(function (f) {
//                                                                    //on annule le téléchargement
//                                                                    if (value.name == f) {
//                                                                        e.element.find(".dx-fileuploader-files-container .dx-fileuploader-cancel-button").eq(index).trigger("dxclick");
//                                                                        lstFile.splice(lstFile.indexOf(value), 1)
//                                                                    }
//                                                                });
//                                                            });
//                                                            e.component.inOnValueChanged = false;
//                                                            e.component.option("uploadUrl", '/ext/handlerexterne.ashx?command=handlerupload&nom_base=' + option.bddCtrl.nom_base + '&dest=' + encodeURI(option.pathTempUpload) + "&notoverwrite=1")
//                                                            e.component._uploadFiles();
//                                                        }
//                                                    }
//                                                });
//                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
//                                                    text: "Remplacer " + ((data.files.length == 1) ? "le fichier" : "les " + data.files.length + " fichiers"),
//                                                    width: "100%",
//                                                    onClick: function () {
//                                                        popQuestion.hide();
//                                                        e.component._uploadFiles();
//                                                    }
//                                                });
//                                                $("<div/>").appendTo(contentElement).dxCtrlButton({
//                                                    text: "Annuler",
//                                                    width: "100%",
//                                                    onClick: function () {
//                                                        popQuestion.hide();
//                                                        funcEndLoading([])
//                                                    }
//                                                });
//                                            }
//                                        },
//                                        onHiding: function (e) { funcEndLoading([]); }
//                                    }).dxCtrlPopupBase("instance")
//                                    popQuestion.show();
//                                }
//                                else { e.component._uploadFiles(); }
//                            },
//                            function () { jauge.mHide(); },
//                            function () { });
//                    }
//                }
//                else {
//                    var lstFileTropGros = mGetLstFileTropGros(e.value)
//                    var message = mGetMessageTropGros(lstFileTropGros)
//                    if (message.length > 0) {
//                        mNotify(message, "warning", 6000 + lstFileTropGros.length * 4000);
//                        funcEndLoading([])
//                    } else {
//                        e.component._uploadFiles();
//                    }
//                }
//            },
//            onContentReady: function (e) {
//                //Me.$containerDragDrop = $(e.component.element().closest(".dx-ctrlfileuploadermachine")[0])
//                if (parametre.isMobile) {
//                    e.component.element().find("input").attr("accept", ((parametre.isMobile ? "image/*,video/*" : "")))
//                } else {
//                    if (typeof option.accept == 'undefined' || option.accept == '') {
//                        e.component.element().find("input").attr("accept", "")
//                    } else if (option.accept.contains(".png") ||
//                        option.accept.contains(".jpg") ||
//                        option.accept.contains(".jpeg") ||
//                        option.accept.contains(".gif") ||
//                        option.accept.contains(".bmp")) {
//                        //e.component.element().find("input").attr("capture", "user")
//                        e.component.element().find("input").attr("accept", "image/*,video/*")
//                    }
//                }

//                Me.$containerDragDrop = $(container.find(".dx-fileuploader-container"))
//                e.component.lstFile = []; e.component.lstFileErreur = []; e.component.lstDivProgress = [];
//                e.component.nbFileInLoad = 0;
//                e.component.inOnValueChanged = false;
//                $DivMess = $("<div style='position:absolute;z-index:6;top:55px;color:gray;width:100%;text-align:center;cursor:pointer;'>ou glissez-déposez les fichiers ici.</div>")
//                $Filigrame = $("<i class='fas fa-cloud-upload-alt' style='user-select:none;position:absolute;font-size:300px;opacity:0.1;z-index:0;'/>");
//                $Background = $("<div style='position:absolute;width:100%;height:100%;background-color:gray;display:none;'/>")
//                $DivContainer.prepend($Filigrame);
//                $DivContainer.prepend($DivMess);
//                $DivContainer.prepend($Background);
//                e.component.element().find(".dx-fileuploader-button").css("display", "none");
//                e.component.element().find(".dx-fileuploader-input-wrapper").css({ "width": "100%", "height": "100%" });
//                e.component.element().css({ position: "relative", "z-index": 0 });
//                e.component.element().find(".dx-fileuploader-wrapper").css("padding", "0");
//                e.component.element().find(".dx-fileuploader-input-wrapper").css("padding", "0");
//                //e.component.element().find(".dx-fileuploader-container").css("padding", "20px");
//                e.component.element().css("cursor", "pointer")
//                e.component.dragenter = false;
//                Me.isInDrag = false;
//                $DivContainer.on("click", function () {
//                    Me.mSelectionneFichier()
//                })
//                Me.$containerDragDrop.on("dragenter", function () {
//                    if (!e.component.dragenter) {
//                        e.component.element().find(".dx-fileuploader-content").css("z-index", 1)
//                        e.component.element().css("z-index", 10);
//                        e.component.element().css("opacity", "0.5");
//                        e.component.element().css("background-color", "transparent");
//                        $Background.show()
//                        //e.component.element().css("border", "3px dashed black");
//                        console.log("dragenter " + (new Date()).getTime() + " - class has drag: " + Me.isInDragOver())
//                        window.setTimeout(function () {
//                            console.log("class has drag: " + Me.isInDragOver());
//                            if (!Me.isInDragOver()) {
//                                e.component.element().css("z-index", 0);
//                                e.component.element().css("opacity", "1");
//                                e.component.element().css("background-color", "transparent");
//                                //e.component.element().css("border", "none");
//                                console.log("dragleave " + (new Date()).getTime())
//                                if (typeof option.onDragEnd != 'undefined') option.onDragEnd($DivContainer)
//                                Me.isInDrag = false;
//                                console.log("isindrag = false")
//                            }
//                        }, 0)
//                        e.component.dragenter = true
//                        Me.isInDrag = true;
//                        console.log("isindrag(enter) = true")
//                    }
//                });
//                Me.$containerDragDrop.on("dragleave", function () {
//                    if (e.component.dragenter) {
//                        console.log("dragleave annule")
//                        e.component.dragenter = false
//                    }
//                    else {
//                        e.component.element().css("z-index", 0);
//                        e.component.element().css("opacity", "1");
//                        e.component.element().css("background-color", "transparent");
//                        $Background.hide()
//                        e.component.element().css("border", "none");
//                        console.log("dragleave " + (new Date()).getTime())
//                        if (typeof option.onDragEnd != 'undefined') option.onDragEnd(Me.$containerDragDrop)
//                        Me.isInDrag = false;
//                        console.log("isindrag = false")
//                    }
//                });
//                Me.$containerDragDrop.on("drop", function () {
//                    //window.setTimeout(function (ee) {
//                    e.component.element().css("z-index", "0");
//                    e.component.element().css("opacity", "1");
//                    e.component.element().css("background-color", "transparent");
//                    e.component.element().find(".dx-fileuploader-input-wrapper").css("display", "none")
//                    $Background.hide()
//                    console.log("drop " + (new Date()).getTime())
//                    if (!e.component.option("value") || e.component.option("value").length == 0) {
//                        e.component.timeOutDrop = window.setTimeout(function () {
//                            funcEndLoading([]);
//                        }, 100);
//                    }
//                    //}, 300)
//                    Me.isInDrag = false;
//                    console.log("isindrag(drop) = false")
//                });
//                if (typeof option.onContentReady != 'undefined') option.onContentReady(e)
//            }
//        }).dxFileUploader("instance");
//        mInitLibelle();
//    }

//    function mInitLibelle() {
//        dxFileUp.option('buttonText', ((option.multiple) ? 'Choisir des fichiers' : "Choisir un fichier"))
//        if ($DivMess) $DivMess.html(((option.multiple) ? 'Cliquez pour choisir des fichiers<br/>ou<br/>glissez-déposez les fichiers ici...' : "Cliquez pour choisir un fichier<br/>ou<br/>glissez-déposez le fichier ici..."))
//    }

//    function mGetLstFileTropGros(lstValue) {
//        var lstFile = []
//        lstValue.forEach(function (f) {
//            var nf = {}
//            for (var prop in f) { nf[prop] = f[prop] }
//            lstFile.push(nf);
//        });
//        var lstFileTropGros = [];
//        lstFile.forEach(function (f) {
//            if (((new cFichier(option.bddCtrl, f.name)).mIsImage() && f.size > option.maxFileSizeOctetImage) || (!(new cFichier(option.bddCtrl, f.name)).mIsImage() && f.size > option.maxFileSizeOctetFichier)) {
//                lstFileTropGros.push({ file: f, max: (((new cFichier(option.bddCtrl, f.name)).mIsImage()) ? option.maxFileSizeOctetImage : option.maxFileSizeOctetFichier) });
//            }
//        });
//        return lstFileTropGros
//    }
//    function mGetMessageTropGros(lstFileTropGros) {
//        if (lstFileTropGros.length > 0) {
//            var txt = "Le fichier suivant est trop gros pour être télétransmis:"
//            if (lstFileTropGros.length > 0) txt = "Les fichiers suivants sont trop gros pour être télétransmis:"
//            lstFileTropGros.forEach(function (fTropGros) {
//                txt += "<br/>Le fichier <b><u>" + fTropGros.file.name + "</u></b> fait <span style='color:red'>" + (Math.round((fTropGros.file.size / 1024 / 1024) * 100) / 100) + "Mo</span> pour une taille maximum de <b style='color:green'>" + (Math.round((fTropGros.max / 1024 / 1024) * 100) / 100) + "Mo</b>"
//            })
//            txt += "<br/><b>Télétransmission annulée.</b>"
//            return txt
//        } else { return "" }
//    }

//    //function mRecalculFiligrane() {
//    //    //$DivMess.css("left", "calc(50% - " + ($DivMess.innerWidth() / 2) + "px)");
//    //    var fontSize = 300
//    //    if (container.innerHeight() < 300) fontSize = container.innerHeight() - 10
//    //    if ($Filigrame) $Filigrame.css({ top: "calc(50% - " + $Filigrame.innerHeight() / 2 + "px)", left: "calc(50% - " + $Filigrame.innerWidth() / 2 + "px)", "font-size": fontSize + "px" })
//    //}

//    this.isInDragOver = function () {
//        return (container.find(".dx-fileuploader-dragover").length >= 1)
//    }

//    //var carInterdit = ['+', '#', '&', '%', ':', '/', '\\', '*', '?', '"', '<', '>', "'", '"', String.fromCharCode(8217)]
//    var maxCarAscii = 255
//    function mRenameFileWithoutCarInterdit(fileName) {
//        fileName = fileName.remplacerTout(String.fromCharCode(8217), "'")
//        carInterditFichier.forEach(function (car) { fileName = fileName.remplacerTout(car, "_") })
//        for (var i = maxCarAscii + 1; i <= 255; i++) {
//            //if (fileName.indexOf(String.fromCharCode(i)) > -1) debugger;
//            fileName = fileName.remplacerTout(String.fromCharCode(i), "_")
//        }
//        return fileName;
//    }

//    function mShowToastErreurFile(lstFile) {
//        var txt = ""
//        lstFile.forEach(function (file) {
//            if (txt.length > 0) txt += " &bull; "
//            txt += "Impossible de télétransmettre le fichier '" + file.name + "'"
//            if (typeof file.abort != 'undefined') { txt += " (Annulé par l'utilisateur)" }
//            if (typeof file.erreur != 'undefined') { txt += "<br><span style='font-size:80%;'>(<i>" + file.erreur + "</i>)</span>" }
//        })
//        mNotify(txt, "error", 12000)
//    }

//    function mClearListFile() {
//        dxFileUp.element().find(".dx-fileuploader-files-container").empty()
//        dxFileUp.lstFile = [];
//        dxFileUp.lstFileErreur = [];
//    }

//    this.mShowJauge = function (tempo) { jauge.mShow(tempo) }
//    var uniquementImage = false;
//    this.mAllowImage = function () {
//        this.mAllowedExtension(".png,.jpg,.jpeg,.gif,.bmp");
//        uniquementImage = true
//    }
//    this.mAllowAll = function () {
//        this.mAllowedExtension("");
//        uniquementImage = false
//    }

//    var timeOutClickButton = null;
//    this.mSelectionneFichier = function () {
//        if (timeOutClickButton) window.clearTimeout(timeOutClickButton);
//        timeOutClickButton = window.setTimeout(function () {
//            dxFileUp._isCustomClickEvent = true;
//            dxFileUp._$fileInput.click();
//        }, 100);
//    }

//    this.element = function () { return container; }


//    mConstruit();
//}